import React, { useState, useEffect } from 'react';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col } from 'reactstrap';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';

//Api
import bairro_api from '../../../api/bairro_api';
import setor_api from '../../../api/setor_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';

// Shared
import FiltroPrefeitura from '../../Shared/FiltroPrefeitura';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Estado inicial para o bairro
function initialStateBairro(prefeitura_id) {
    return {
        bairro: "",
        setor_Id: "",
        prefeitura_Id: prefeitura_id ? prefeitura_id : 0
    }
}
export default function Bairros({ permissao }) {

    //Estado que guarda o id da prefeitura selecionada no select das prefeituras no ambiente privado ou da prefeitura default no ambiente público
    const [prefeitura_Id, setPrefeitura_Id] = useState(null);
    const handlePrefeitura = (value) => {
        setPrefeitura_Id(value);
        loadRegionais(value);
        loadBairros(value);
        setBairro(initialStateBairro(value));
    }

    //Estado controle de exibição do modal
    const [openModal, setOpenModal] = useState(false);

    //Controle de exibição do loading
    const [loading, setLoading] = useState(false);

    //Controle dos erros dos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Campos obrigatorios
    const campos = [objCampo({ name: "bairro", required: true }), objCampo({ name: "setor_Id", required: true })]

    //Controle do estado de exibição do modal
    const toggleModal = () => {
        if (openModal) {
            setBairro(initialStateBairro(prefeitura_Id));
            setErrors({});
        }
        if (!prefeitura_Id) {
            showMessage("Aviso", "Escolha uma prefeitura para adicionar um bairro", "info");
        } else {
            setOpenModal(!openModal);
        }

    };

    //Guarda a lista de bairros
    const [bairros, setBairros] = useState([]);

    //Guarda os dados para adição/edição de um bairro
    const [bairro, setBairro] = useState(initialStateBairro);

    //Guarda as opções do select de regionais
    const [optionsRegionais, setOptionsRegionais] = useState([]);

    //Variavel que guarda as actions da tabela
    const actions = [];

    //Carrega os dados do bairro a ser editado no modal
    function editarBairro(item, itemKey) {
        setLoading(true);
        bairro_api.GetItem(item.id).then(response => {
            response.data.setor_Id = response.data.setor_Id.toString();
            setBairro(response.data);
            setLoading(false);
            toggleModal();
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })

    }

    //Adiciona o botão de editar na tabela caso a permissão seja de editar
    if (permissao === "Editar") {
        actions.push(actionsTable.editar(editarBairro))
    }
    //Carrega a lista de bairros
    function loadBairros(_prefeitura_id) {
        setLoading(true);
        bairro_api.GetList(_prefeitura_id).then(response => {
            setBairros(response.data);
            setLoading(false);
        }).catch(e => {
            showMessage("Aviso", e.Message, "error");
            setLoading(false);
        })
    }

    //Carrega as opções de regionais
    function loadRegionais(_prefeitura_id) {
        setor_api.GetList(_prefeitura_id).then(response => {
            const _optionsRegionais = response.data.map(setor => {
                return { text: setor.descricao, value: setor.id }
            })
            _optionsRegionais.unshift({ text: "Selecione", value: "" });
            setOptionsRegionais(_optionsRegionais);
        }).catch(e => {
            showMessage("Aviso", e.message, "error");
        })
    }

    //Change para os campos de cadastro/edição de um bairro
    const onChangeBairro = (e) => {
        const { name, value } = e.target;


        const _bairro = {
            ...bairro,
            [name]: value
        }
        const erros = validarCampos(_bairro, campos.filter(c => c.name == name));
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        }
        setBairro(_bairro);
    }

    //Adiciona/edita um bairro
    const addNovoBairro = () => {
        const erros = validarCampos(bairro, campos);
        setErrors(erros[0]);
        if (erros[1].length > 0) {
            return;
        }
        const _bairro = { ...bairro, setor_Id: parseInt(bairro.setor_Id) };

        setLoading(true);
        if (_bairro.id) {
            bairro_api.Put(_bairro).then(response => {
                showMessage("Sucesso", "Bairro atualizado com sucesso!", "success");
                loadBairros(prefeitura_Id);
                setBairro(initialStateBairro(prefeitura_Id));
                toggleModal();
                setLoading(false);
            }).catch(e => {
                showMessage("Aviso", e.message, "error");
                setLoading(false);
            })
        } else {
            bairro_api.Post(_bairro).then(response => {
                showMessage("Sucesso", "Bairro adicionado com sucesso!", "success");
                loadBairros(prefeitura_Id);
                setBairro(initialStateBairro(prefeitura_Id));
                toggleModal();
                setLoading(false);
            }).catch(e => {
                showMessage("Aviso", e.message, "error");
                setLoading(false);
            })

        }
    }

    //Cabeçalhos da tabela de bairros
    const headers = [
        { value: "Identificação", objectValue: "bairro", align: "left" },
        { value: "Regional", objectValue: "setor", align: "left" },
    ]

    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={toggleModal}>
                <FiltroPrefeitura handleValue={handlePrefeitura}></FiltroPrefeitura>
                <div className="mt-4">
                    <TabelaListagem options={{ print: false, search: true, pagination: true }} actions={actions} title='Lista de bairros' headers={headers} items={bairros} />
                </div>
                <ModalCustomized isOpen={openModal} title={bairro.id ? <><FontAwesomeIcon icon={faEdit} className={"me-2"} /> Editar</> : "+ Novo Bairro"} toggle={toggleModal} btnAction={bairro.id ? <><FontAwesomeIcon icon={faEdit} className={"me-2"} /> Editar</> : "+ Adicionar"} btnActionColor={bairro.id ? "warning text-light" : "success"} onClickBtnAction={addNovoBairro} btnClose>

                    <Row>
                        <Col md="12" lg="6">
                            <TextField maxLength={"150"} label={"* Identificação"} name={"bairro"} value={bairro.bairro} onChange={onChangeBairro} invalid={errors.bairro ? true : false} />
                            <PrintValidate errors={errors} field={"bairro"} />
                        </Col>

                        <Col md="12" lg="6">
                            <TextField label={"* Regional"} name={"setor_Id"} type={"select"} options={optionsRegionais} value={bairro.setor_Id} onChange={onChangeBairro} invalid={errors.setor_Id ? true : false} />
                            <PrintValidate errors={errors} field={"setor_Id"} />
                        </Col>
                    </Row>
                </ModalCustomized>
            </MainCard>
        </>
    )
}
